import React from 'react';
import { getMiraRecruiterEntry, useOpenBriefCreationDrawer } from '@fiverr-private/dm_brief_creation_triggers';
import { Card, Stack, Container } from '@fiverr-private/layout_components';
import type { ClientInitialProps } from '@fiverr-private/listing_types';
import { Typography, Link, Text } from '@fiverr-private/typography';
import { ArrowRightIcon, DynamicBriefL2Icon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../../i18n';

const DM_PREFIX = 'empty_results.empty_search_results.dynamic_matching';

interface GenerateBriefProps {
    currency: ClientInitialProps['currency'];
}

export const GenerateBrief = ({ currency }: GenerateBriefProps) => {
    const { openBriefCreationDrawer } = useOpenBriefCreationDrawer();

    return (
        <Card background="linear-gradient(85.53deg, #FFFFFF 57.43%, #F8F9E5 114.23%)" borderRadius="lg" padding="6">
            <Stack direction="row" gap="4">
                <Stack direction="column" gap="2">
                    <Stack direction="row">
                        <Text fontWeight="bold">
                            <AppI18n k={`${DM_PREFIX}.mira_title`} />
                        </Text>
                    </Stack>
                    <Typography fontSize="b_sm" color="grey_1100">
                        <AppI18n k={`${DM_PREFIX}.mira_description`} />
                    </Typography>
                    <Stack alignItems="center">
                        <Link
                            fontSize="b_sm"
                            fontWeight="semibold"
                            color="grey_1100"
                            cursor="pointer"
                            onClick={() => {
                                openBriefCreationDrawer({
                                    currency,
                                    source: 'search_perseus',
                                    isInMiraAgenticBriefsRollout: true,
                                    identificationModalOptions: {
                                        source: 'search_perseus',
                                        triggerType: 'blocked_action',
                                        blockedActionType: 'post_a_brief',
                                        triggerId: 'generate_brief',
                                        triggerCopy: 'Generate brief',
                                        triggerPlacement: 'generate_brief',
                                        triggerComments: 'Generate brief blocked action',
                                        skipQuestionnaire: true,
                                        afterSigningSuccess: () =>
                                            window.location.assign(getMiraRecruiterEntry().miraUrl),
                                    },
                                });
                            }}
                        >
                            <AppI18n k={`${DM_PREFIX}.mira_button`} />
                        </Link>
                        <ArrowRightIcon />
                    </Stack>
                </Stack>
                <Container flexShrink="0">
                    <DynamicBriefL2Icon />
                </Container>
            </Stack>
        </Card>
    );
};
